// import { IconEarn } from '@/assets/ic_earn';
import { IconFuture } from '@/assets/ic_future';
import { IconMarket } from '@/assets/ic_market';
import { IconFeed, IconOrder } from '@/assets/ic_order';
import { IconPortfolio } from '@/assets/ic_portfolio';
import { useAddress } from '@/store/selector';
import { useTradeStore } from '@/store/trade-store';
import clsx from 'clsx';
import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import { useShallow } from 'zustand/shallow';

const nav_data = [
    {
        title: 'Assets',
        icon: <IconPortfolio className="w-7 h-7" />,
        href: '/portfolio',
    },
    {
        title: 'Market',
        icon: <IconMarket className="w-7 h-7" />,
        href: '/market',
    },
    {
        title: 'Trade',
        icon: <IconFuture className="w-7 h-7" />,
        href: '/future',
    },
    {
        title: 'Feed',
        icon: <IconFeed />,
        href: '/feed',
    },
    {
        title: 'Order',
        icon: <IconOrder className="w-7 h-7" />,
        href: '/orders',
    },

    // {
    //     title: 'Earn',
    //     icon: <IconEarn className="w-7 h-7" />,
    //     href: '/earn',
    // },
];

const NavOrder = ({
    item,
    address,
}: {
    item: {
        title: string;
        icon: JSX.Element;
        href: string;
    };
    address: string;
}) => {
    const { t } = useTranslation();

    const { count } = useTradeStore(
        useShallow((state) => ({
            count: state.count,
        }))
    );
    return (
        <NavLink
            to={address ? item.href : '/'}
            className={({ isActive }) => {
                return clsx(
                    'flex flex-col items-center justify-between transition-all ',
                    {
                        'text-white fill-white': isActive && address,
                        'text-[#4C4C4C] fill-[#4C4C4C]': !isActive || !address,
                    }
                );
            }}
        >
            <div className="relative pl-1">
                {item.icon}{' '}
                {!!count.openTrade && (
                    <p className="absolute bg-[#1966F7] rounded-[5px] text-xs px-1 text-white leading-[16px] top-[-5px] right-0">
                        {count.openTrade}
                    </p>
                )}
            </div>
            <p className="text-xs font-medium ">{t(item.title)}</p>
        </NavLink>
    );
};

export function NavigationView() {
    const address = useAddress();
    const { t } = useTranslation();
    return (
        <nav
            className={clsx(
                'flex-shrink-0 grid grid-cols-5 bg-black pb-8 pt-6 z-[99]'
            )}
        >
            {nav_data.map((item, idx) => {
                if (item.title === 'Order') {
                    return <NavOrder key={idx} item={item} address={address} />;
                }

                if (item.href === '/feed') {
                    return (
                        <NavLink
                            to={address ? item.href : '/'}
                            key={idx}
                            className={({ isActive }) => {
                                return clsx(
                                    'flex flex-col items-center justify-between transition-all',
                                    {
                                        'text-white fill-white':
                                            isActive && address,
                                        'text-amber-400 fill-[#4C4C4C]':
                                            !isActive || !address,
                                    }
                                );
                            }}
                        >
                            <div className="pl-1">{item.icon}</div>
                            <p className="text-xs font-medium">
                                {t(item.title)}
                            </p>
                        </NavLink>
                    );
                }

                return (
                    <NavLink
                        to={address ? item.href : '/'}
                        key={idx}
                        className={({ isActive }) => {
                            return clsx(
                                'flex flex-col items-center justify-between transition-all',
                                {
                                    'text-white fill-white':
                                        isActive && address,
                                    'text-[#4C4C4C] fill-[#4C4C4C]':
                                        !isActive || !address,
                                    '!text-amber-400': item.href === '/feed',
                                }
                            );
                        }}
                    >
                        <div className="pl-1">{item.icon}</div>
                        <p className="text-xs font-medium">{t(item.title)}</p>
                    </NavLink>
                );
            })}
        </nav>
    );
}
